import { Check, ChevronDown, Building2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export const CLIENT_SCOPED_ROLES = new Set(["ta_recruiter", "ta_lead", "tag_lead", "recruiter"]);

export default function ClientMultiSelect({ clients, value, onChange, testid, compact = false, placeholder = "Select clients" }) {
  const names = clients.filter(c => value.includes(c.id)).map(c => c.name);
  const toggle = (id) => onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`inline-flex items-center gap-1.5 justify-between rounded-lg bg-[color:var(--bg-elev)] border border-[color:var(--bd-sub)] hover:border-indigo-400 text-left min-w-0 ${compact ? "text-xs px-2 py-1 max-w-[200px]" : "w-full px-3 py-2 text-sm"}`}>
          <span className="inline-flex items-center gap-1.5 min-w-0">
            <Building2 className="w-3.5 h-3.5 text-slate-400 shrink-0" />
            <span className={`truncate ${names.length ? "text-slate-800" : "text-slate-400"}`}>{names.length ? names.join(", ") : placeholder}</span>
          </span>
          <ChevronDown className="w-3.5 h-3.5 text-slate-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-64 p-1.5" data-testid={`${testid}-menu`}>
        {clients.length === 0 && <div className="text-xs text-slate-500 p-2">No clients yet — onboard them on the Clients page.</div>}
        {clients.map(c => {
          const on = value.includes(c.id);
          return (
            <button type="button" key={c.id} data-testid={`${testid}-opt-${c.id}`} onClick={() => toggle(c.id)}
              className="w-full flex items-center gap-2 px-2 py-1.5 rounded-md text-sm hover:bg-slate-100 text-left">
              <span className={`w-4 h-4 rounded border grid place-items-center shrink-0 ${on ? "bg-indigo-600 border-indigo-600" : "border-slate-300"}`}>
                {on && <Check className="w-3 h-3 text-white" />}
              </span>
              <span className="truncate">{c.name}</span>
            </button>
          );
        })}
      </PopoverContent>
    </Popover>
  );
}
